// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import LRU from 'lru-cache';
import { shouldUsePwrDistroEndpoint } from 'config/pwrDistroClientIds';

const cache = LRU({ max: 5, maxAge: 1000 * 60 * 5 });

type Props = {
  clientId: Id,
  channelName: string,
  endDateTime?: string,
  isPwrDistro?: boolean,
  pageNumber?: number,
};
const getChannelContent = wrapWithNetworkError(function getChannelContent(
  token: string,
  { clientId, channelName, endDateTime, isPwrDistro, pageNumber }: Props
) {
  const usePwrDistro = shouldUsePwrDistroEndpoint(channelName, isPwrDistro);
  const pathPrefix = usePwrDistro
    ? '/moderate/content/pwr-distro'
    : '/moderate/content';

  // Build query string based on endpoint type
  let queryString = '';
  if (usePwrDistro) {
    // Pwr-distro uses search API parameters
    const params = new URLSearchParams();
    params.append('sort_order', 'desc');
    params.append('max_page_results', '100');
    if (pageNumber != null) {
      params.append('page_number', String(pageNumber));
    }
    if (endDateTime) {
      params.append('end_date', endDateTime);
    }
    queryString = `?${params.toString()}`;
  } else {
    // Non-distro uses end_date_time
    queryString = endDateTime ? `?end_date_time=${endDateTime}` : '';
  }

  const fetchUrl = getEndpointUrl(
    `${pathPrefix}/client/${clientId}/channel/${channelName}${queryString}`
  );
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  if (cache.has(fetchUrl)) {
    const data = cache.get(fetchUrl);
    if (data) {
      // this probably shouldn't be here
      // we introduce a delay so the spinner shows up and the page
      // looks less jerky
      return new Promise(resolve => setTimeout(resolve, 10, data));
      // return Promise.resolve(data);
    }
  }

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => {
      if (response.status === 204) {
        return [];
      }

      return response.json();
    })
    .then((json: GetContentResponse) => (Array.isArray(json) ? json : [json]))
    .then(response => {
      cache.set(fetchUrl, response);
      return response;
    });
});

export default getChannelContent;



// WEBPACK FOOTER //
// ./src/api/content/getChannelContent.js